import { sortDate } from "../../utils.js";
import { getValidDispatchesForBookClub } from "../../subscription-product/utils/getFutureDispatches.js";
export const getNextBookClubDispatch = (dispatches, renewAt, dispatchBatchCode) => {
    const sortedDispatches = [...(dispatches ?? [])].sort(({ distributionDate: a }, { distributionDate: b }) => sortDate(a, b));
    if (sortedDispatches.length === 0) {
        return undefined;
    }
    const renewAtDate = renewAt?.slice(0, 10);
    if (renewAtDate) {
        const dispatchMatchingRenewCycle = sortedDispatches.find((dispatch) => dispatch.distributionDate?.slice(0, 10) === renewAtDate);
        if (dispatchMatchingRenewCycle) {
            return dispatchMatchingRenewCycle;
        }
        // renewAt exists but no dispatch matches that date.
        // Fall back to batchCode or first actionable dispatch.
    }
    if (dispatchBatchCode) {
        const dispatchMatchingBatchCode = sortedDispatches.find((dispatch) => dispatch.batchCode === dispatchBatchCode);
        if (dispatchMatchingBatchCode) {
            return dispatchMatchingBatchCode;
        }
    }
    const actionableDispatches = getValidDispatchesForBookClub(dispatches ?? []).sort(({ distributionDate: a }, { distributionDate: b }) => sortDate(a, b));
    if (actionableDispatches.length === 0) {
        return undefined;
    }
    return actionableDispatches[0];
};
/**
 * Whether a member's dispatch lies beyond the club's next one. A member who
 * has skipped or paused lands on a later dispatch, and that book is not shown
 * before the club's next dispatch has gone out.
 */
export const isDispatchBeyondNext = (dispatches, dispatch, now = new Date()) => {
    if (!dispatch?.distributionDate)
        return false;
    const clubNext = [...(dispatches ?? [])]
        .filter(({ distributionDate }) => !!distributionDate && new Date(distributionDate) >= now)
        .sort(({ distributionDate: a }, { distributionDate: b }) => sortDate(a, b))[0];
    if (!clubNext?.distributionDate)
        return false;
    return (dispatch.distributionDate.slice(0, 10) >
        clubNext.distributionDate.slice(0, 10));
};
